/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

/**
 * Removes `__typename` meta field from object at any depth.
 * Caution: Use only when necessary, as the cost of parsing and stringifying objects is not trivial!
 */
export const omitTypename = (data: object) => {
  const _omitTypename = (key: string, value: any) => (key === '__typename' ? undefined : value);
  return JSON.parse(JSON.stringify(data), _omitTypename);
};
